import { useMutation, useQueryClient } from '@tanstack/react-query'
import { removeAgendaMemberService } from '@/services/agendas'

export const useRemoveAgendaMember = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (targetUserId: string) => removeAgendaMemberService(agendaId, targetUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendas', agendaId, 'members'] })
    },
  })
}
